export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8544.8bcb027a.jpg";